<div class="hideable-container">
  <input type="checkbox" [checked]="isShowContent" [id]="switchId" (change)="onButtonChange()"

  /><label [for]="switchId"></label>
  <div [class.hide]="!isShowContent">
    <ng-content>

    </ng-content>
  </div>
</div>
